import { format, parseISO } from 'date-fns';
import { Input } from '../Form';
import DatePicker from 'react-datepicker';
import React from 'react';
import { createPortal } from 'react-dom';
import 'react-datepicker/dist/react-datepicker.css';
import './react-datepicker.css';
import Icon from '../Icon/Icon';
import { Flex } from 'rebass';

const PopperContainer: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return createPortal(children, document.body);
};

type MonthDayPickerProps = {
  startDate?: string | null;
  endDate?: string | null;
  onChange?: (startDate: string | null, endDate: string | null) => void;
  autoFocus?: boolean;
  minDate?: Date;
  maxDate?: Date;
  variant?: 'inputSquare' | 'input' | 'inputRoundedRight' | 'inputRoundedLeft';
};

export const MonthDayPicker: React.FC<MonthDayPickerProps> = ({
  endDate,
  startDate,
  onChange,
  autoFocus,
  minDate,
  maxDate,
  variant,
}) => {
  return (
    <DatePicker
      selectsRange
      startDate={startDate ? parseISO(startDate) : null}
      endDate={endDate ? parseISO(endDate) : null}
      onChange={([startDate, endDate]) => {
        onChange?.(
          startDate ? format(startDate, 'yyyy-MM-dd') : null,
          endDate ? format(endDate, 'yyyy-MM-dd') : null
        );
      }}
      customInput={
        <Input
          variant={variant}
          sx={{ cursor: 'default' }}
          width={170}
          autoComplete="off"
        />
      }
      showIcon
      icon={
        <Flex
          alignItems="center"
          sx={{ pointerEvents: 'none' }}
          justifyContent="center"
        >
          <Icon size="13" icon="calendar" />
        </Flex>
      }
      isClearable
      dateFormat="MMM d"
      showYearPicker={false}
      minDate={minDate ?? parseISO('2010-01-01')}
      maxDate={maxDate ?? parseISO('2050-12-31')}
      // minDate={startDate ? parseISO(startDate) : undefined}
      monthsShown={2}
      autoFocus={autoFocus}
      popperContainer={PopperContainer}
      popperProps={{ strategy: 'fixed' }}
    />
  );
};
